// Temporary hardcoded list of codes that require excise confirmation
// In future this will be decided by backend API call - but required now as a quick fix for OPS
export const CODES_WITH_EXCISE = ['2106909849', '2103909089'];
